import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ fontSizes, fontWeights, breakpoints }: Theme) => ({
  root: {
    position: 'absolute',
    width: '9rem',
    padding: '0.5rem',
    borderRadius: '0.5rem',
    background: 'rgba(255, 255, 255, 0.9)',
    fontSize: fontSizes['3xs'],
    lineHeight: 1.17,
    boxShadow: '3px 4px 13px 0 rgba(5, 41, 103, 0.1)',
    [breakpoints.down(321)]: {
      padding: '0.3rem',
    },
    [breakpoints.up('xl')]: {
      width: '15rem',
      fontSize: fontSizes.xs,
      lineHeight: 1.4,
    },
  },
  strong: {
    display: 'block',
    marginBottom: 2,
    fontSize: fontSizes.xxs,
    lineHeight: 1.17,
    fontWeight: fontWeights.medium,
    [breakpoints.up('xl')]: {
      fontSize: fontSizes.sm,
      lineHeight: 1.5,
    },
  },
  arrow: {
    position: 'absolute',
    display: 'block',
    width: '1rem',
    height: '1rem',
    '&.top-left': {
      top: '-1rem',
      left: '-1rem',
    },
    '&.top-right': {
      top: '-1rem',
      right: '-1rem',
    },
    '&.bottom-right': {
      bottom: '-1rem',
      right: '-1rem',
    },
    '&.bottom-left': {
      bottom: '-1rem',
      left: '-1rem',
    },
  },
}));
